import React, { useState } from 'react';
import { Box, Container, Typography, Link as MuiLink, Stack, Divider } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Email as EmailIcon, LocationOn as LocationIcon } from '@mui/icons-material';
import { useAdmin } from '../contexts/AdminContext';
import AdminPinModal from './AdminPinModal';

const Footer: React.FC = () => {
  const { isAdmin } = useAdmin();
  const navigate = useNavigate();
  const [pinModalOpen, setPinModalOpen] = useState(false);

  const handleCopyrightClick = () => {
    if (isAdmin) {
      navigate('/admin');
    } else {
      setPinModalOpen(true);
    }
  };

  return (
    <>
    <Box
      component="footer"
      sx={{
        mt: 6,
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid #F0E6DA',
        py: { xs: 3, md: 4 },
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' }, gap: 3, mb: 3 }}>
          {/* Brand */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
              Amruthakalasam
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Professional Vedic Astrology consultations by Acharya Malyala Srinivas.
            </Typography>
          </Box>
          {/* Quick links */}
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>Quick Links</Typography>
            <Stack spacing={0.5}>
              {[
                { to: '/services', label: 'Services' },
                { to: '/book-slot', label: 'Book Slot' },
                { to: '/contact', label: 'Contact' },
                { to: '/terms', label: 'Terms' },
                { to: '/privacy', label: 'Privacy' },
              ].map((l) => (
                <MuiLink key={l.to} component={Link} to={l.to} color="text.secondary" underline="hover" sx={{ fontSize: 13 }}>
                  {l.label}
                </MuiLink>
              ))}
            </Stack>
          </Box>
          {/* Contact info */}
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>Contact</Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mb: 1 }}>
              <EmailIcon sx={{ fontSize: 16, mt: 0.3, color: 'text.secondary' }} />
              <Typography variant="body2" sx={{ color: 'text.secondary', wordBreak: 'break-word' }}>
                amruthakalasamastrology@gmail.com
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
              <LocationIcon sx={{ fontSize: 16, mt: 0.3, color: 'text.secondary' }} />
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Huda Sai Nagar, Kamala Nagar, Hyderabad, Telangana — 500070
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            textAlign: 'center',
            fontSize: 12,
            cursor: 'pointer',
            userSelect: 'none',
            '&:hover': { opacity: 0.8 },
          }}
          onClick={handleCopyrightClick}
        >
          © 2024 Amruthakalasam. All rights reserved.
        </Typography>
      </Container>
    </Box>
    <AdminPinModal
      open={pinModalOpen}
      onClose={() => setPinModalOpen(false)}
      onSuccess={() => navigate('/admin')}
    />
    </>
  );
};

export default Footer;
